export default __webpack_public_path__ + "0ace6ce687ba067525fad0073410105d.png";